"use client";

import { useUser } from "@/lib/context/user-context";
import { Badge } from "@/components/ui/badge";
import { CheckCircle2 } from "lucide-react";
import { useI18n } from "@/lib/i18n";

type ExampleCompletionIndicatorProps = {
  done: boolean | null;
  loading?: boolean;
};

export function ExampleCompletionIndicator({ done, loading = false }: ExampleCompletionIndicatorProps) {
  const { user } = useUser();
  const { t } = useI18n();

  if (!user?.id) return null;

  if (loading) {
    return (
      <Badge variant="outline" className="text-xs opacity-70">
        {t("course.progress.loading")}
      </Badge>
    );
  }

  return done ? (
    <div className="flex items-center text-green-600 text-xs gap-1">
      <CheckCircle2 className="h-4 w-4" /> {t("course.progress.status.completed")}
    </div>
  ) : (
    <Badge variant="outline" className="text-xs">{t("course.progress.status.todo")}</Badge>
  );
}
